module.exports = __webpack_public_path__ + "img/telfordt.0e8350f9.jpg";